export interface TagSwatchProps {
  hex?: string | null;
  name?: string | null;
  className?: string;
}

/**
 * The price-tag colour of an umbrella product, as a small dot. The name rides
 * along as the title and screen-reader text, since a colour alone says nothing
 * to someone who cannot see it.
 */
export function TagSwatch({ hex, name, className = '' }: TagSwatchProps) {
  if (!hex) return null;
  const label = name ? `${name} tag` : 'Tag colour';
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={`inline-block h-3 w-3 flex-shrink-0 rounded-full border border-black/10 ${className}`}
      style={{ backgroundColor: hex }}
    />
  );
}
